import { graphql } from 'app/generated/gql'

import { MODEL_FIELDS } from 'app/generated/modelFields'

export const PALETTE_CONTACTS_QUERY = graphql(`
  query PaletteContacts($search: String, $pagination: PaginationInput, $sort: SortInput) {
    contacts(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        version
        createdDate
        updatedDate
        id
        patientIds
        patientName
        orgId
        workspaceId
        locationId
        name
        preferredName
        homePhone
        cellPhone
        workPhone
        otherPhone
        email
        birthDate
        addressLine1
        addressLine2
        lifecycleStage
        patientStatus
        leadStatus
        isQualified
        appointmentStatus
        nearestAppointmentDate
        city
        state
        zip
        becameLeadDate
        becamePatientDate
        patientCreatedDate
        firstAppointmentMadeDate
        firstAppointmentDate
        lastAppointmentDate
        firstTransactionDate
        lastTransactionDate
        lastHygieneDate
        hygieneDueDate
        isPerio
        tags
        matchTypes
        collectedLtv
        productionLtv
        scheduledProduction
        unbookedTreatmentValue
        lastTreatmentPlanDate
        fvv
        adClickDate
        patientReferral
        lastActivityDate
        lastCommDate
        lastCommActivityType
        lastCommActivitySubType
        utmSource
        utmMedium
        utmCampaign
        utmKeywords
        utmContent
        platform
        trackableCampaignId
        leadOwner {
          id
          name
          aliases
          userId
        }
        channel
        smsMarketingConsent
        firstContactReason
        firstActivityType
        activityTypes
        convertedBy {
          id
          name
          aliases
          userId
        }
        firstActivityDate
        becameInactiveDate
        closedLostReason
        preferredCommunicationMethod
        preferredContact
        archived
        pipelines {
          id
          stage
          key
        }
        neededAction
        reportedAttribution
        activityCount
        needsActionDate
        firstName
        lastName
      }
      total
      page
    }
  }
`)

export const PALETTE_MESSAGES_QUERY = graphql(`
  query PaletteMessages($search: String, $pagination: PaginationInput, $sort: SortInput) {
    messages(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        version
        createdDate
        updatedDate
        id
        orgId
        workspaceId
        locationId
        threadId
        from
        to
        callerId
        sentByUserId
        isAgent
        isInitialMessage
        aiWorkflowId
        aiWorkflowName
        workflowRunId
        direction
        contactId
        channel
        category
        subject
        text
        read
        archived
        status
        provider
        providerMessageId
        errorCode
        errorMessage
        images
      }
      total
      page
    }
  }
`)

export const PALETTE_ACTIVITIES_QUERY = graphql(`
  query PaletteActivities($search: String, $pagination: PaginationInput, $sort: SortInput) {
    activities(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        version
        createdDate
        updatedDate
        id
        orgId
        workspaceId
        locationId
        archived
        contacts {
          id
          name
          phone
          matchDate
          nameFromActivity
          peopleIndex
          lifecycleStage
          locationId
        }
        contactCount
        type
        typeId
        subType
        description
        note
        activityDate
        needsReview
        reviewReason
        matchTypes
        contactName
        contactPhone
        nameFromActivity
        nameSource
        phoneFromActivity
        source
        utmSource
        utmMedium
        utmCampaign
        utmKeywords
        utmContent
        referringUrl
        tags
        owner {
          id
          name
          aliases
          userId
        }
        utmAccountId
        utmCampaignId
        trackableCampaignId
        vendor
        fbclid
        gclid
        data
        email
        channel
        isQualified
        smsMarketingOptIn
        trackingNumber
        trackingNumberName
      }
      total
      page
    }
  }
`)
